/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not load sync status." |
*
* @param {Admin_Status_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_load_error = /** @type {((inputs?: Admin_Status_Load_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_Load_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger l'état de la synchronisation.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo cargar el estado de la sincronización.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível carregar o status da sincronização.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare lo stato della sincronizzazione.")
	return /** @type {LocalizedString} */ ("Could not load sync status.")
});